import { types } from "../types/types"

export const clearUI = () => ({
    type: types.uiClearState
})

// loading
export const startLoading = () => ({

    type: types.uiStartLoading
})

export const finishLoading = () => ({
    type: types.uiFinishLoading
})

// loading departamentos
export const startLoadingDepartamento = () => ({
    type: types.uiStartLoadingDepartamento
});

export const finishLoadingDepartamento = () => ({
    type: types.uiFinishLoadingDepartamento
});

// loading cargo
export const startLoadingCargo = () => ({
    type: types.uiStartLoadingCargo
})

export const finishLoadingCargo = () => ({
    type: types.uiFinishLoadingCargo
})

// loading sucursales
export const startLoadingSucursal = () => ({
    type: types.uiStartLoadingSucursal
})

export const finishLoadingSucursal = () => ({
    type: types.uiFinishLoadingSucursal
})